export default __webpack_public_path__ + "static/media/banner1.8609c853.jpg";